import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.451 11.579a.75.75 0 1 0-1.06-1.06l-2.241 2.24-2.241-2.24a.75.75 0 0 0-1.06 1.06l2.24 2.24-2.24 2.242a.75.75 0 0 0 1.06 1.06l2.24-2.24 2.242 2.24a.75.75 0 0 0 1.06-1.06l-2.24-2.241z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.836 5.68h3.869v-.945a2.75 2.75 0 0 1 2.75-2.75h3.39a2.75 2.75 0 0 1 2.75 2.75v.945h3.868a.75.75 0 0 1 0 1.5h-1.097v12.03a2.75 2.75 0 0 1-2.75 2.75H7.684a2.75 2.75 0 0 1-2.75-2.75V7.18H3.836a.75.75 0 1 1 0-1.5m2.598 1.5v12.03c0 .69.56 1.25 1.25 1.25h8.932c.69 0 1.25-.56 1.25-1.25V7.18zm8.66-1.5h-5.89v-.945c0-.69.56-1.25 1.25-1.25h3.39c.69 0 1.25.56 1.25 1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }